// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/forms/fields/Checkbox/index.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/forms/fields/Checkbox/index.tsx");
  import.meta.hot.lastModified = "1732036225881.1157";
}
// REMIX HMR END

import { clsx } from "clsx";
import { forwardRef } from "react";
export const Checkbox = forwardRef(_c = ({
  className,
  ...props
}, ref) => <input ref={ref} type="checkbox" {...props} className={clsx("bg-neutral-50 checked:accent-primary-600 rounded-sm ", className)} />);
_c2 = Checkbox;
var _c, _c2;
$RefreshReg$(_c, "Checkbox$forwardRef");
$RefreshReg$(_c2, "Checkbox");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;